import AudioContent from './AudioContent'

export default AudioContent
